(function () {
  function applyTwoUp(container) {
    if (!container) return;
    container.classList.add('og-two-up');

    // Säkerställ att Shop Pay fyller sin kolumn
    var sp = container.querySelector('.shopify-payment-button');
    if (sp) {
      sp.style.margin = '0';
      sp.style.width = '100%';
      var spBtn = sp.querySelector('.shopify-payment-button__button');
      if (spBtn) spBtn.style.width = '100%';
    }
  }

  function observePayment(container) {
    if (!container || container.__ogObserver) return;
    const mo = new MutationObserver(() => applyTwoUp(container));
    mo.observe(container, { childList: true, subtree: true });
    container.__ogObserver = mo;
  }

  function initForSection(sectionId) {
    // Din knapprad ligger i detta element
    var container =
      document.getElementById('Quantity-Form-' + sectionId) ||
      document.querySelector(`#product-form-${sectionId}`)?.closest('.product-form__buttons-group') ||
      document.querySelector('.product-form__buttons-group');

    applyTwoUp(container);
    observePayment(container);
  }

  // Kör vid laddning
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(function (pi) {
      var sectionId = pi.dataset.originalSection || pi.dataset.section;
      if (sectionId) initForSection(sectionId);
    });
  });

  // Kör efter varje variantbyte (temat dispatchar redan detta event)
  document.addEventListener('afterVariantChanged', function (e) {
    var sectionId = e.detail && e.detail.sectionId;
    if (sectionId) initForSection(sectionId);
  });
})();
